
export enum ChargingType {
  AC= 'AC',
  DC= 'DC',
  PantographCharger= 'PantographCharger',
  Induction= 'Induction',
  BatterySwapping= 'BatterySwapping',

}